export default __webpack_public_path__ + "static/media/Jaskaran_Kaur_Resume.7f0ce9e3.pdf";